import { mapState } from 'vuex'
// api
import ModelService from '@/services/model.service'

export default {
  name: 'Community',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [9, 20, 47, 65, 82],
      pageIdList: '',
      pageIdList_pc: [29, 98, 105, 114, 120],
      pageIdList_mp: [235, 231, 238, 241, 244],
      pageIdListTwo: '',
      pageIdListTwo_pc: [30, 99, 106, 115, 121],
      pageIdListTwo_mp: [236, 232, 239, 242, 245],
      // data
      pageInfo: '',
      pageInfoTwo: '',
      bannerInfo: '',
      factoryPopupStatus: false,
      curType: '',
      galleryParams: [
        {
          param: {
            factoryName: 'EVN'
          },
          query: {
            sid: 21,
            tid: 25,
          },
          factory: {
            sid: 21,
            tid: 26,
          },
        },
        {
          param: {
            factoryName: 'EVH'
          },
          query: {
            sid: 30,
            tid: 34,
          },
          factory: {
            sid: 30,
            tid: 35,
          },
        },
        {
          param: {
            factoryName: 'EVM'
          },
          query: {
            sid: 39,
            tid: 43,
          },
          factory: {
            sid: 39,
            tid: 44,
          },
        },
        {
          param: {
            factoryName: 'EVC'
          },
          query: {
            sid: 48,
            tid: 52,
          },
          factory: {
            sid: 48,
            tid: 53,
          },
        },
        {
          param: {
            factoryName: 'PRB'
          },
          query: {
            sid: 57,
            tid: 61,
          },
          factory: {
            sid: 57,
            tid: 62,
          },
        },
        {
          param: {
            factoryName: 'PBB'
          },
          query: {
            sid: 66,
            tid: 70,
          },
          factory: {
            sid: 66,
            tid: 71,
          },
        },
      ],
      pageName: '',
      pageName_cn: {
        more: '查看更多',
      },
      pageName_en: {
        more: 'see more',
      },
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex', 'factoryList'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.switchAdlist();
  },
  methods: {
    init() {
      this.getBannerList();
      this.getPageInfo();
      this.getPageInfoTwo();
      this.initLang();
    },
    initLang() {
      if (this.LangIndex === 1) {
        this.pageName = this.pageName_cn;
      } else {
        this.pageName = this.pageName_en;
      };
    },
    // 根据客户端切换广告位id
    switchAdlist() {
      if (this.isPC) {
        this.pageIdList = this.pageIdList_pc;
        this.pageIdListTwo = this.pageIdListTwo_pc;
      } else {
        this.pageIdList = this.pageIdList_mp;
        this.pageIdListTwo = this.pageIdListTwo_mp;
      }
      this.init();
    },
    // 根据id获取页面内容
    getPageInfo() {
      const param = {
        id: this.pageIdList[this.LangIndex],
      };
      ModelService.getPageInfo(param).then((res) => {
        if (res.code === 0) {
          this.pageInfo = res.data;
        }
      });
    },
    // 根据id获取页面内容
    getPageInfoTwo() {
      const param = {
        id: this.pageIdListTwo[this.LangIndex],
      };
      ModelService.getPageInfo(param).then((res) => {
        if (res.code === 0) {
          this.pageInfoTwo = res.data;
        }
      });
    },
    // 根据id获取广告图片
    getBannerList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.bannerInfo = res.data[0];
        }
      });
    },
    // 打开工厂列表弹层
    switchFactoryPopup(target) {
      this.curType = target || '';
      this.factoryPopupStatus = !this.factoryPopupStatus;
    },
    // 数据过滤
    even(numbers, target) {
      return numbers.filter( (number) => {
        return number.param.factoryName === target
      })
    },
    // 跳转对应相册
    goGalleryPage(name) {
      const urls = this.even(this.galleryParams, name)[0];
      this.$tools.go({
        name: 'Gallery',
        params: urls.param,
        query: urls[this.curType],
      });
    },
  },
};
